import { useEffect } from 'react';

import { formGuid } from '@/environment';
import { useReadmeioLogin } from '@/hooks/useReadmeioLogin';
import { useAuth } from '@/services/auth';
import { submitForm } from '@/services/hubspot';

export const Docs = () => {
    const getUrl = useReadmeioLogin();
    const { user } = useAuth();

    useEffect(() => {
        if (!!user?.email) {
            submitForm(formGuid, { email: user.email }, [{ eventName: 'api_documentation', eventValue: 'true' }]);
        }
        getUrl().then(url => {
            if (url) {
                window.location.href = url;
            }
        });
    }, [getUrl, user]);

    return <></>;
};
